export default __webpack_public_path__ + "fef5e3f9a7ae122c75a2c7b3f4e4a1fa.png";